// The one label drawn above every StyledInput field, at 12 px. `aside` sits
// at the right end of the label row (an info icon, a counter). With
// `htmlFor`, it is the <label> of a field it does not wrap (a phone number,
// whose country select and input share one box).
const FieldLabel = ({ label, isOptional, aside, htmlFor }) => {
  if (!label && !aside) return null;
  const Tag = htmlFor ? 'label' : 'div';

  return (
    <Tag
      htmlFor={htmlFor}
      className={`text-xs font-normal text-gray-500 ${
        aside ? 'flex items-center justify-between gap-2' : 'block'
      }`}
    >
      <span className={'flex gap-1'}>
        {label}
        {isOptional && <span className="text-gray-400"> - Optionnel</span>}
      </span>
      {aside}
    </Tag>
  );
};

export default FieldLabel;
